<ng-container *transloco="let t">
  <header class="top-header">
    <div class="header-container-logo">
      <button
        class="nav-menu-button hidden-print"
        [ngClass]="{ active: navActive && !quickActionsOpen }"
        (click)="onNavBtnClick()"
        [attr.aria-label]="t('Side Navigation Toggle')"
        (keydown.tab)="sideNavTab($event)">
        <span class="nav-menu-icon"></span>
      </button>
      <a routerLink="/" (click)="quickActionsToggled.emit(false)" class="logo" [attr.aria-label]="productName">
        <svg-icon [src]="(themeService.theme$ | async)?.iconUrl()"></svg-icon>
      </a>
    </div>
    <kp-core-nav
      class="nav-component-container hidden-print"
      [quickActionsOpen]="quickActionsOpen"
      (quickActionsToggled)="quickActionsToggled.emit($event)"></kp-core-nav>
    <div class="header-container-tertiary-visible">
      @if (externalProduct === product.purposeful) {
        <kp-purposeful-day-indicator
          (purposefulDaysClicked)="quickActionsToggled.emit(false)"></kp-purposeful-day-indicator>
      }
      <div class="header-container-tertiary hidden-print">
        <a
          routerLink="/help"
          (click)="quickActionsToggled.emit(false)"
          routerLinkActive="header-active"
          class="button-help"
          [attr.aria-label]="t('Help')">
          <svg-icon src="/assets/icons/question-filled-circle.svg"></svg-icon>
        </a>
        @if (moreApps(); as moreApps) {
          @if (moreApps.length > 1) {
            <kui-app-switcher
              class="app-switcher-wrap"
              [apps]="moreApps"
              (appClicked)="appClicked($event)"
              (appDrawerOpened)="quickActionsToggled.emit(false)"></kui-app-switcher>
          }
        }
      </div>
    </div>
  </header>
</ng-container>
